import { TableHeadersType } from "./tableHeadersType";

export const DAILY_ACTIVE_USER_COUNT_HEADERS: TableHeadersType[] = [
  {
    label: "Date",
    value: "Date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Internal Active Users",
    value: "internal_active_users",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "External Active Users",
    value: "external_active_users",
    defaultChecked: true,
    checked: true,
  },
];
export const USER_SESSION_LOGIN_COUNT_HEADERS: TableHeadersType[] = [
  {
    label: "Name",
    value: "first_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Email",
    value: "email",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Hit Count",
    value: "hit_count",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Login Count",
    value: "login_count",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Session Count",
    value: "session_count",
    defaultChecked: true,
    checked: true,
  },
];

export const monthlyUserCountReportDropDown = [
  {
    value: "",
    label: "Select..",
  },
  {
    value: "2023-2024",
    label: "2023-2024",
  },
  {
    value: "2022-2023",
    label: "2022-2023",
  },
  {
    value: "2021-2022",
    label: "2021-2022",
  },
];

export const MONTHLY_ACTIVE_USER_COUNT_HEADERS: TableHeadersType[] = [
  {
    label: "Year",
    value: "Year",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Month",
    value: "Month",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Internal Active Users",
    value: "internal_active_users",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "External Active Users",
    value: "external_active_users",
    defaultChecked: true,
    checked: true,
  },
];

export const USER_REPORT_COUNT_HEADERS: TableHeadersType[] = [
  {
    label: "Date",
    value: "date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total Hit Count",
    value: "total_hit_count",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Total Session Count",
    value: "total_session_count",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Login Count",
    value: "login_count",
    defaultChecked: true,
    checked: true,
  },
];
